import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Cody Cline Direct Sales July 2025 Data
const jobData = [  {
    jobInfo: "E-475: Jeffrey Kahn",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 18049.73,
    grossMarginPct: 0.4774,
    grossProfit: 8616.94,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 18049.73 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-480: Pennrose Management Pointe View",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 2340.00,
    grossMarginPct: 0.4231,
    grossProfit: 990.05,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2340.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-491: The Enclave at Ellicott hills",
    leadSource: "Referral- Dominic's network",
    trade: "Solar Install",
    contractTotal: 1200.00,
    grossMarginPct: 0.3000,
    grossProfit: 360.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1200.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-492: Ellicott Hills Condo 3",
    leadSource: "Referral- Dominic's network",
    trade: "Solar Install",
    contractTotal: 491.00,
    grossMarginPct: 0.3000,
    grossProfit: 147.30,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 491.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-459: Georgetown Hill 584",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 3580.00,
    grossMarginPct: 0.4839,
    grossProfit: 1732.36,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3580.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-497: John Tabor Kanter Project",
    leadSource: "Referral- Cody's network",
    trade: "Gutters",
    contractTotal: 1176.00,
    grossMarginPct: 0.4167,
    grossProfit: 490.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1176.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-467: Pesh Peramune",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 6795.45,
    grossMarginPct: 0.3842,
    grossProfit: 2610.81,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6795.45 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-493: Julie Jones",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 95475.84,
    grossMarginPct: 0.5380,
    grossProfit: 51366.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 95475.84 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-471: Simone Moore",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 26470.56,
    grossMarginPct: 0.4424,
    grossProfit: 11710.58,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 26470.56 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-494: Deborah Spriggs, Chair, Board of Trustees People's Congregational United Church of Christ",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 27947.73,
    grossMarginPct: 0.4631,
    grossProfit: 12942.59,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 27947.73 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-454: David Steckel",
    leadSource: "Referral- Dominic's network",
    trade: "Gutters",
    contractTotal: 2527.27,
    grossMarginPct: 0.4064,
    grossProfit: 1027.08,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2527.27 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-448: Mary Habicht",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 10264.75,
    grossMarginPct: 0.4754,
    grossProfit: 4879.86,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 10264.75 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-472: Adam Gregory",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 6200.00,
    grossMarginPct: 0.5273,
    grossProfit: 3269.26,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6200.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-482: Casey Maker",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 6098.00,
    grossMarginPct: 0.2910,
    grossProfit: 1774.52,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6098.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-495: Brian Karr",
    leadSource: "Referral- Cody's network",
    trade: "Skylight Replacement",
    contractTotal: 6626.27,
    grossMarginPct: 0.4695,
    grossProfit: 3111.03,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6626.27 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-490: Danny Day",
    leadSource: "Referral- Dominic's network",
    trade: "Solar Install",
    contractTotal: 4251.72,
    grossMarginPct: 0.3000,
    grossProfit: 1275.52,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4251.72 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-501: Jake BAR-LIN Construction",
    leadSource: "Referral- Cody's network",
    trade: "Gutters",
    contractTotal: 727.00,
    grossMarginPct: 0.3000,
    grossProfit: 218.10,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 727.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-443: Cara Fitzwater",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 2278.00,
    grossMarginPct: 0.4805,
    grossProfit: 1094.58,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2278.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2862: Jordan Gottlieb",
    leadSource: "Referral",
    trade: "Solar Install",
    contractTotal: 79100.00,
    grossMarginPct: 0.3000,
    grossProfit: 23730.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 79100.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-2919: Glenford Blanc",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 36739.00,
    grossMarginPct: 0.3000,
    grossProfit: 11021.70,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 36739.00 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals from CSV
const totalContractValue = 338338.32;
const totalGrossProfit = 142368.33;
const totalCompanyOH = 52442.44;

// For Cody reports, calculate based on the formula
const totalNetProfit = totalGrossProfit - totalCompanyOH;
const totalSalesCommissions = totalNetProfit / 2; // 50% of net profit
const totalManagerFees = 0; // No manager fees for Cody

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

// Export the final report data object
export const codySalesJulyData: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody's direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Previous Customer", spend: 0 },
    { source: "Referral - From past customer", spend: 0 },
    { source: "Referral", spend: 0 },
    { source: "Site Survey Website", spend: 0 }
  ],
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,
  period: {
    month: 7, // July
    year: 2025
  }
};